import { render, staticRenderFns } from "./AuditAccesses.vue?vue&type=template&id=90762292&"
import script from "./AuditAccesses.ts?vue&type=script&lang=ts&"
export * from "./AuditAccesses.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports